import SearchIcon from '@mui/icons-material/Search'
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import Button from '@mui/material/Button'
import { useState } from 'react'

import ClearIcon from '@mui/icons-material/Clear'
import { Dayjs } from 'dayjs'
import DateRangePicker from '../../../../../../../components/DateRangePicker'
import ExportExcel from '../../../../../../../components/Export'
import SelectSearch, {
  IOptionSelect,
} from '../../../../../../../components/SelectSearch'
import useAxios from '../../../../../../../hooks/useAxios'
import {
  EExpiredDateStatus,
  ILeadAssignTo,
} from '../../../../../../../types/lead'
import { PaginationResponseInterface } from '../../../../../../../types/pagination'
import {
  ETrackingNotificationsStatusCalled,
  ETrackingNotificationsStatusFollow,
} from '../../../../../../../types/trackingNotification'
import UserSelectSearch from '../../../../../../../components/SelectSearch/UserSelectSearch'

export interface IFilterMapped {
  page?: number
  perPage?: number
  startDate?: string
  endDate?: string
  assignToObjectId?: string
  expiredDateStatus?: EExpiredDateStatus
  followStatus?: ETrackingNotificationsStatusFollow
  calledStatus?: ETrackingNotificationsStatusCalled
}

interface FilterProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
  onResetFilter: () => void
  onDownload?: (date: Dayjs) => void
}

const menuItemsTypeCalledStatus = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'รอโทร',
    value: ETrackingNotificationsStatusCalled.NOT_CALLED,
  },
  {
    label: 'โทรแล้ว',
    value: ETrackingNotificationsStatusCalled.CALLED,
  },
  {
    label: 'ไม่รับสาย',
    value: ETrackingNotificationsStatusCalled.CANCEL_CALLED,
  },
]

const menuItemsTypeFollowStatus = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'รอติดตาม',
    value: ETrackingNotificationsStatusFollow.WAIT,
  },
  {
    label: 'ติดตามแล้ว',
    value: ETrackingNotificationsStatusFollow.DONE,
  },
]

const menuItemsTypeStatusDate = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'ใช้งาน',
    value: EExpiredDateStatus.NOT_EXPIRED,
  },
  {
    label: 'หมดอายุ',
    value: EExpiredDateStatus.EXPIRED,
  },
]

const LeadListFollowFilter = (props: FilterProps) => {
  const { onFilterChange, filter, onSearch, onDownload, onResetFilter } = props
  const { page, perPage, startDate, endDate } = filter

  const [searchAssignToList, setSearchAssignToList] = useState<string>('')
  const [resetAutoComplete, setResetAutoComplete] = useState<string>('')
  const assignToList = useAxios<PaginationResponseInterface<ILeadAssignTo>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchAssignToList,
      startDate: '',
      endDate: '',
    },
  })
  const handleSearchAssignToList = async (value: string) => {
    setSearchAssignToList(value)
    await assignToList.mutate()
  }

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={6}>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          disableFuture={false}
          onChange={(startDate, endDate) => {
            onFilterChange({ ...filter, startDate, endDate })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={3}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="followStatus-label">เลือกการติดตาม</InputLabel>
          <Select
            id="followStatus"
            name="followStatus"
            labelId="followStatus-label"
            value={filter.followStatus ?? ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                followStatus: e.target
                  .value as ETrackingNotificationsStatusFollow,
              })
            }
            fullWidth
          >
            <MenuItem value="">
              <em>เลือกสถานะการติดตาม</em>
            </MenuItem>
            {menuItemsTypeFollowStatus.map((item, index: number) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={3}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="calledStatus-label">เลือกการโทร</InputLabel>
          <Select
            id="calledStatus"
            name="calledStatus"
            labelId="calledStatus-label"
            value={filter.calledStatus ?? ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                calledStatus: e.target
                  .value as ETrackingNotificationsStatusCalled,
              })
            }
            fullWidth
          >
            <MenuItem value="">
              <em>เลือกสถานะการโทร</em>
            </MenuItem>
            {menuItemsTypeCalledStatus.map((item, index: number) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={3}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="expiredDateStatus-label">สถานะ</InputLabel>
          <Select
            id="expiredDateStatus"
            name="expiredDateStatus"
            labelId="expiredDateStatus-label"
            value={filter.expiredDateStatus ?? ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                expiredDateStatus: e.target.value as EExpiredDateStatus,
              })
            }
            fullWidth
          >
            <MenuItem value="">
              <em>เลือกสถานะ</em>
            </MenuItem>
            {menuItemsTypeStatusDate.map((item, index: number) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={3}>
        <UserSelectSearch
          label={'เลือกผู้ดูแล'}
          resetAutoComplete={resetAutoComplete}
          onSelect={(e) => {
            onFilterChange({ ...filter, assignToObjectId: e?.value.objectId })
          }}
          name="user"
        />
        {/* <SelectSearch<ILeadAssignTo>
          resetAutoComplete={resetAutoComplete}
          label={'เลือกผู้ดูแล'}
          onSelect={(e) =>
            onFilterChange({ ...filter, assignToObjectId: e?.value.objectId })
          }
          search={searchAssignToList}
          onSearch={handleSearchAssignToList}
          options={
            assignToList.data?.records
              .filter((assignTo: ILeadAssignTo) => assignTo.isAvailable)
              .map((assignTo: ILeadAssignTo) => ({
                label: assignTo.name,
                value: assignTo,
              })) || ([] as IOptionSelect<ILeadAssignTo>[])
          }
        /> */}
      </Grid>
      <Grid item xs={8} lg={2}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onResetFilter()
            setResetAutoComplete(new Date().getTime().toString())
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
      <Grid item xs={12} lg={2}>
        <ExportExcel onDownload={onDownload} />
      </Grid>
    </Grid>
  )
}

export default LeadListFollowFilter
